export const BankAccountFormKeys = {
  account_holder_name: true,
  account_holder_type: true,
  routing_number: true,
  account_number: true,
  country: true,
  currency: true
};
